import { render } from "./ShopCar.vue?vue&type=template&id=2b850192&scoped=true"
import script from "./ShopCar.vue?vue&type=script&lang=ts"
export * from "./ShopCar.vue?vue&type=script&lang=ts"

import "./ShopCar.vue?vue&type=style&index=0&id=2b850192&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b850192"

export default script